import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { TranslateResponseDto } from '../models/translate-response.dto';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(value: string): Observable<string> {
    if (!value) {
      return of(null);
    }

    return this.translateService
      .getTranslateText(value)
      .pipe(map((res: TranslateResponseDto) => res.responseData.translatedText));
  }
}
